export class CreateTransactionRequest {
    constructor(input: Partial<CreateTransactionRequest> = {}) {
        Object.assign(this, input);
    }

    paymentAmount: number;

    submissionId: string;
}
